var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelEct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1453 16.9663C20.0208 17.9266 18.7731 18.7146 17.4445 19.3162L16.2535 15.891H17.9451V15.2455C17.9451 13.2142 16.2925 11.5615 14.2611 11.5615H9.12915H8.31747L7.92752 10.2702H13.6474V8.97914H7.53758L5.51834 2.29283L5.5076 2.25725L5.49278 2.22309C5.09561 1.30549 4.36265 0.603204 3.42885 0.245788C2.49505 -0.111584 1.48051 -0.0783261 0.572104 0.339547L0.0656721 0.572481L4.5558 15.8909H5.86648L4.67082 19.368C3.29908 18.7602 2.01191 17.9542 0.855054 16.9662L0.0166016 17.948C3.07607 20.561 6.97679 22 11.0002 22C15.0236 22 18.9243 20.561 21.9838 17.948L21.1453 16.9663ZM1.63606 1.34008C2.07713 1.24959 2.53565 1.28619 2.96732 1.4515C3.56296 1.67949 4.03278 2.12336 4.29377 2.70374L6.18887 8.97909H3.87521L1.63606 1.34008ZM4.25368 10.2702H6.57877L6.96871 11.5614H4.63215L4.25368 10.2702ZM5.52277 14.5999L5.01058 12.8526H7.35861H9.12915H14.2611C15.3571 12.8526 16.2832 13.593 16.5657 14.5999H5.52277ZM11.0001 20.7089C9.24229 20.709 7.50991 20.4111 5.87301 19.8422L7.23173 15.891H14.8864L16.2457 19.8C14.574 20.3961 12.8005 20.7089 11.0001 20.7089Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelEct);
export default __webpack_public_path__ + "static/media/sel_ect.c8c9dc2534def71b67c6501e72988a5b.svg";
export { ForwardRef as ReactComponent };